import {
  Button,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material'
import {makeStyles} from '@mui/styles'
import {FC, useState} from 'react'
import {useTranslate} from 'react-admin'

import {ChatMessageTemplateValues} from '../../../types/graphqlSchema'
import DialogCloseButton from '../../DialogCloseButton'
import ExtendedDialog from '../../ExtendedDialog'
import {AddIcon, SendIcon} from '../../icons'
import ChatMessageTemplateBuilder from '../ChatMessageTemplateBuilder'

const TemplateMessageComposerDialog: FC<TemplateMessageComposerDialogProps> = ({
  isOpen = false,
  isSendingTemplateChatMessage = false,
  onClose,
  onSendTemplateChatMessage,
}) => {
  const translate = useTranslate()
  const styles = useStyles()
  const [canSendTemplate, setCanSendTemplate] = useState(false)
  const [chatMessageTemplateId, setChatMessageTemplateId] = useState<string>()
  const [chatMessageTemplateValues, setChatMessageTemplateValues] =
    useState<ChatMessageTemplateValues[]>([])
  return (
    <ExtendedDialog
      maxWidth="md"
      onClose={onClose}
      open={isOpen}
    >
      <DialogTitle>{translate('dialogs.templateMessageComposer.title')}</DialogTitle>
      <DialogCloseButton className={styles.dialogCloseButton} onClick={onClose} />
      <DialogContent>
        {translate('dialogs.templateMessageComposer.subtitle')}
        <ChatMessageTemplateBuilder
          onChangePlaceholders={setChatMessageTemplateValues}
          onChangeTemplateId={setChatMessageTemplateId}
          onValidatePlaceholders={setCanSendTemplate}
          templateId={chatMessageTemplateId}
        />
      </DialogContent>
      <DialogActions className={styles.dialogActions}>
        <Button
          color="primary"
          href="/chat_message_templates/create"
          startIcon={<AddIcon />}
          variant="outlined"
        >
          {translate('resources.chat_message_templates.action.create')}
        </Button>
        <Button
          color="primary"
          disabled={!canSendTemplate || isSendingTemplateChatMessage}
          onClick={() => {
            chatMessageTemplateId && onSendTemplateChatMessage({
              chatMessageTemplateId: chatMessageTemplateId,
              chatMessageTemplateValues,
            })
          }}
          startIcon={
            isSendingTemplateChatMessage ? <CircularProgress size={20} /> : <SendIcon />
          }
          variant="contained"
        >
          {translate('actions.send')}
        </Button>
      </DialogActions>
    </ExtendedDialog>
  )
}

const useStyles = makeStyles(theme => ({
  dialogActions: {
    paddingRight: theme.remSpacing(1.5),
  },
  dialogCloseButton: {
    [theme.breakpoints.up('lg')]: {
      right: theme.spacing(0),
    },
  },
}))

interface TemplateMessageComposerDialogProps {
  isOpen?: boolean
  isSendingTemplateChatMessage?: boolean
  onClose: () => void
  onSendTemplateChatMessage: OnSendTemplateChatMessage
}

export default TemplateMessageComposerDialog
